import type { ServiceStatusCheck } from '../model/types';


interface WindowStats {
    total: number;
    passed: number;
}

export function getWindowStats (checks: ServiceStatusCheck[], windowMs: number, now: number): WindowStats {
    const recent = checks.filter((check) => !check.clientError && now - check.timestamp <= windowMs);
    const passed = recent.filter((check) => check.ok).length;

    return { total: recent.length, passed };
}
